import React from 'react';
import { Button } from '@/components/ui/button';
import { Download, Loader2 } from 'lucide-react';
import { useDashboardExport } from '../hooks/useDashboardExport';
import type { DashboardFilters } from '../types/dashboard.types';
import type { DashboardExportEndpoint } from '../api/dashboardExport.api';

interface DashboardExportButtonProps {
  endpoint: DashboardExportEndpoint;
  filters?: DashboardFilters;
  disabled?: boolean;
  label?: string;
}

export const DashboardExportButton: React.FC<DashboardExportButtonProps> = ({ 
  endpoint,
  filters, 
  disabled = false,
  label = "Descargar Excel"
}) => {
  const { exportToExcel, isExporting } = useDashboardExport();

  const handleExport = () => {
    exportToExcel({ endpoint, filters });
  };

  return (
    <Button
      onClick={handleExport}
      disabled={disabled || isExporting}
      variant="outline"
      size="sm"
      className="flex items-center gap-2"
    >
      {isExporting ? (
        <Loader2 className="h-4 w-4 animate-spin" />
      ) : (
        <Download className="h-4 w-4" />
      )}
      {isExporting ? 'Generando...' : label}
    </Button>
  );
};